<button mat-button
        id="{{name}}"
        name="{{name}}"
        disabled="{{disabled}}"
        [ngClass]="{'large-btn': size === 'large',
            'medium-btn': size === 'medium',
            'small-btn': size === 'small'  }">
    <mat-icon [ngClass]="{'large-icon': size === 'large','medium-icon': size === 'medium' ,'small-icon': size === 'small'  }">{{icon}} </mat-icon>
</button>
